import { MaterialModule } from 'src/app/material/material.module';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartiesService } from './service/parties.service';
import { ContactMechanismsService } from './service/contact-mechanisms.service';
import { ViewPartyContactMechanismComponent } from './view-party-contact-mechanism/view-party-contact-mechanism.component';
import { EditPartyContactMechanismComponent } from './edit-party-contact-mechanism/edit-party-contact-mechanism.component';
import { PartyRolesService } from './service/party-roles.service';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { PersonsService } from './service/persons.service';

import { PipesModule } from 'src/app/pipes/pipes.module';
import { ViewPartyContactMechanismInlineComponent } from './view-party-contact-mechanism-inline/view-party-contact-mechanism-inline.component';

const components = [ViewPartyContactMechanismComponent, EditPartyContactMechanismComponent, ViewPartyContactMechanismInlineComponent];

@NgModule({
    declarations: [components],
    imports: [CommonModule, MaterialModule, ReactiveFormsModule, FormsModule, PipesModule, CommonComponentsModule],
    exports: [components]
})
export class PartyModule {
    static forRoot(): ModuleWithProviders<PartyModule> {
        return {
            ngModule: PartyModule,
            providers: [PartiesService, ContactMechanismsService, PartyRolesService, PersonsService]
        };
    }
}
